// Paths of the file should be the same as we have inside project folder

export const CHEVRON_DOWN_ICON_URL =
  "/static/images/icons/coreicon-pro/chevron down.svg";
export const CHEVRON_RIGHT_ICON_URL =
  "/static/images/icons/coreicon-pro/chevron right.svg";
export const CHEVRONS_RIGHT_ICON_URL =
  "/static/images/icons/coreicon-pro/chevrons right.svg";
export const CHEVRON_LEFT_ICON_URL =
  "/static/images/icons/coreicon-pro/chevron left.svg";
export const CALLING_ICON_URL = "/static/images/icons/coreicon-pro/calling.svg";
export const APPS_ICON_URL = "/static/images/icons/coreicon-pro/apps.svg";
export const BUS_ICON_URL = "/static/images/icons/coreicon-pro/bus.svg";
export const CART_ICON_URL = "/static/images/icons/coreicon-pro/cart.svg";
export const DASHBOARD_ICON_URL =
  "/static/images/icons/coreicon-pro/dashboard.svg";
export const EYE_ICON_URL = "/static/images/icons/coreicon-pro/eye.svg";
export const USD_ICON_URL = "/static/images/icons/coreicon-pro/usd.svg";
export const PRINT_ICON_URL = "/static/images/icons/coreicon-pro/print.svg";
export const CORNER_UP_RIGHT_ICON_URL =
  "/static/images/icons/coreicon-pro/corner up right.svg";
export const CORNER_BOTTOM_RIGHT_ICON_URL =
  "/static/images/icons/coreicon-pro/corner bottom right.svg";
export const LOCATION_ALT_ICON_URL =
  "/static/images/icons/coreicon-pro/location alt.svg";
export const DISCOVERY_ICON_URL =
  "/static/images/icons/coreicon-pro/delivery.svg";
export const PROFILE_ICON_URL = "/static/images/icons/coreicon-pro/profile.svg";
export const COLLECTIONS_ICON_URL =
  "/static/images/icons/coreicon-pro/collections.svg";
export const TICKET_ICON_URL = "/static/images/icons/coreicon-pro/ticket.svg";
export const UNLIKE_ICON_URL = "/static/images/icons/coreicon-pro/unlike.svg";
export const MORE_ICON_URL =
  "/static/images/icons/coreicon-pro/more circle.svg";
export const PLUS_ICON_URL = "/static/images/icons/coreicon-pro/plus.svg";
export const EDIT_ICON_URL = "/static/images/icons/coreicon-pro/edit.svg";
export const STORE_ICON_URL = "/static/images/icons/coreicon-pro/store.svg";
export const MINUS_ICON_URL = "/static/images/icons/coreicon-pro/minus.svg";
export const REPEAT_ONE_ICON_URL =
  "/static/images/icons/coreicon-pro/repeat one.svg";
export const SORT_TWO_ARROWS_ICON_URL =
  "/static/images/icons/coreicon-pro/sort two arrow.svg";
export const CLOCK_ICON_URL =
  "/static/images/icons/coreicon-pro/time circle.svg";
export const ARROW_RIGHT_ICON_URL =
  "/static/images/icons/coreicon-pro/arrow right.svg";
export const ARROW_TOP_RIGHT_ICON_URL =
  "/static/images/icons/coreicon-pro/arrow top right.svg";
export const PIN_MAP_ICON_URL = "/static/images/icons/coreicon-pro/pin map.svg";
export const CHECK_ICON_URL = "/static/images/icons/coreicon-pro/check.svg";
export const FILTER_ICON_URL = "/static/images/icons/coreicon-pro/filter.svg";
export const EARTH_ICON_URL = "/static/images/icons/coreicon-pro/earth.svg";
export const HOME_ICON_URL = "/static/images/icons/coreicon-pro/home.svg";
export const HR_ALIGN_C_ICON_URL =
  "/static/images/icons/coreicon-pro/hr align c.svg";
export const STAR_ICON_URL = "/static/images/icons/coreicon-pro/star.svg";
export const USERS_GROUP_ICON_URL =
  "/static/images/icons/coreicon-pro/users group.svg";
export const ADD_TAG_ICON_URL = "/static/images/icons/coreicon-pro/add tag.svg";
export const ALERT_CIRCLE_ICON_URL =
  "/static/images/icons/coreicon-pro/alert circle.svg";
export const DELIVERY_ICON_URL =
  "/static/images/icons/coreicon-pro/delivery.svg";
export const REPORT_ICON_URL = "/static/images/icons/coreicon-pro/report.svg";
export const SHIELD_DONE_ICON_URL =
  "/static/images/icons/coreicon-pro/shield done.svg";
export const COUNTRY_ICON_URL = "/static/images/icons/coreicon-pro/country.svg";
export const LOGIN_ICON_URL = "/static/images/icons/coreicon-pro/login.svg";
export const CARD_ICON_URL = "/static/images/icons/coreicon-pro/card.svg";
export const SIDEBAR_ICON_URL = "/static/images/icons/coreicon-pro/sidebar.svg";
export const TRASH_ICON_URL = "/static/images/icons/coreicon-pro/trash.svg";
export const WALLET_ICON_URL = "/static/images/icons/coreicon-pro/wallet.svg";
export const BOOKMARK_ICON_URL =
  "/static/images/icons/coreicon-pro/bookmark.svg";
export const PAPER_ICON_URL = "/static/images/icons/coreicon-pro/paper.svg";
export const СOLLECTIONS_ICON_URL =
  "/static/images/icons/coreicon-pro/collections.svg";
export const DOWNLOAD_ICON_URL =
  "/static/images/icons/coreicon-pro/download.svg";
export const SEARCH_ICON_URL = "/static/images/icons/coreicon-pro/search.svg";
export const MESSAGE_ICON_URL = "/static/images/icons/coreicon-pro/message.svg";
export const CALL_ICON_URL = "/static/images/icons/coreicon-pro/call.svg";
export const SHARE_ICON_URL = "/static/images/icons/coreicon-pro/share.svg";
export const SHARE_ALT_ICON_URL =
  "/static/images/icons/coreicon-pro/share alt.svg";
export const LOCATION_ICON_URL =
  "/static/images/icons/coreicon-pro/location.svg";
export const FACEBOOK_ICON_URL =
  "/static/images/icons/coreicon-pro/facebook.svg";
export const INSTAGRAM_ICON_URL =
  "/static/images/icons/coreicon-pro/instagram.svg";
export const PINTEREST_ICON_URL =
  "/static/images/icons/coreicon-pro/pinterest.svg";
export const YOUTUBE_ICON_URL = "/static/images/icons/coreicon-pro/youtube.svg";
export const ALERT_TRIANGLE_ICON_URL =
  "/static/images/icons/coreicon-pro/alert triangle.svg";
export const COPY_ICON_URL = "/static/images/icons/coreicon-pro/copy.svg";
export const TOOLTIP_CIRCLE_URL =
  "/static/images/icons/coreicon-pro/tooltip circle.svg";
export const PLUS_CIRCLE_URL =
  "/static/images/icons/coreicon-pro/plus circle.svg";
export const CHECK_CIRCLE_ICON_URL =
  "/static/images/icons/coreicon-pro/check circle.svg";
export const CLOSE_ICON_URL = "/static/images/icons/coreicon-pro/close.svg";
export const SETTINGS_ICON_URL =
  "/static/images/icons/coreicon-pro/settings.svg";
export const CLOSE_SQUARE_ICON_URL =
  "/static/images/icons/coreicon-pro/close square.svg";
export const LINK_ICON_URL = "/static/images/icons/coreicon-pro/link.svg";
export const LIKE_ICON_URL = "/static/images/icons/coreicon-pro/like.svg";
export const CHART_ICON_URL = "/static/images/icons/coreicon-pro/chart.svg";
export const DISCOUNT_WAVE_ICON_URL =
  "/static/images/icons/coreicon-pro/discount wave.svg";
export const DISCOUNT_ICON_URL =
  "/static/images/icons/coreicon-pro/discount square.svg";
export const LATEST_ICON_URL = "/static/images/icons/coreicon-pro/latest.svg";
export const EXPORT_ICON_URL = "/static/images/icons/coreicon-pro/export.svg";
export const REFRESH_ICON_URL = "/static/images/icons/coreicon-pro/refresh.svg";
export const REFRESH_DOUBLE_ICON_URL =
  "/static/images/icons/coreicon-pro/refresh double.svg";
export const FILTER_ALT_ICON_URL =
  "/static/images/icons/coreicon-pro/filter alt.svg";
export const IMAGE_ICON_URL = "/static/images/icons/coreicon-pro/image.svg";
export const MINUS_CIRLCE_ICON_URL =
  "/static/images/icons/coreicon-pro/minus circle.svg";
export const DIRECTION_ICON_URL =
  "/static/images/icons/coreicon-pro/direction.svg";
export const CORNER_RIGHT_DOWN_ICON_URL =
  "/static/images/icons/coreicon-pro/corner right down.svg";
export const FLASH_ICON_URL = "/static/images/icons/coreicon-pro/flash.svg";
export const CHAT_ICON_URL = "/static/images/icons/coreicon-pro/chat.svg";
export const FB_MESSANGER_ICON_URL =
  "/static/images/icons/coreicon-pro/fb messanger.svg";
export const VIBER_ICON_URL = "/static/images/icons/viber.svg";
export const SEND_ICON_URL = "/static/images/icons/coreicon-pro/send.svg";
export const UNDO_ICON_URL = "/static/images/icons/coreicon-pro/undo.svg";
export const RIGHT_SQUARE_ICON_URL =
  "/static/images/icons/coreicon-pro/right square.svg";
export const ATTACH_ICON_URL = "/static/images/icons/coreicon-pro/attach.svg";
export const USERS_TWO_ICON_URL =
  "/static/images/icons/coreicon-pro/users two.svg";
export const COLUMNS_ICON_URL = "/static/images/icons/coreicon-pro/columns.svg";
export const CHECK_DOUBLE_ICON_URL =
  "/static/images/icons/coreicon-pro/check double.svg";
export const DOOR_ICON_URL = "/static/images/icons/door.svg";
export const STAIRS_ICON_URL = "/static/images/icons/stairs.svg";
export const SEAT_ICON_URL = "/static/images/icons/seat.svg";
export const SPECIAL_SEAT_ICON_URL = "/static/images/icons/special-seat.svg";
export const TABLE_ICON_URL = "/static/images/icons/table.svg";
export const TABLE_VERTICAL_ICON_URL =
  "/static/images/icons/table-vertical.svg";
export const TABLE_HORIZONTAL_ICON_URL =
  "/static/images/icons/table-horizontal.svg";
export const WINDSHIELD_ICON_URL = "/static/images/icons/windshield.svg";
export const WINDSHIELD_HORIZONTAL_ICON_URL =
  "/static/images/icons/windshield-horizontal.svg";
export const TIME_CIRCLE_ICON_URL =
  "/static/images/icons/coreicon-pro/time circle.svg";
export const BUS_LOCATION_ICON_URL = "/static/images/icons/bus-location.svg";
export const STOP_LOCATION_ICON_URL = "/static/images/icons/stop-location.svg";
export const EXIT_FULLSCREEN_ICON_URL =
  "/static/images/icons/coreicon-pro/exit fullscreen.svg";
export const FULLSCREEN_ICON_URL =
  "/static/images/icons/coreicon-pro/fullscreen.svg";
export const HEART_ICON_URL = "/static/images/icons/coreicon-pro/heart.svg";
export const ARROW_UP_ICON_URL =
  "/static/images/icons/coreicon-pro/arrow up.svg";
